import Loader from "@components/ui/Loader/Loader";

function LoadingPage() {

    return (
        <div className="p-3">
            <Loader/>
        </div>
    );
}

export default LoadingPage;
